import { withStyles } from "@material-ui/core";
import { format } from "date-fns";
import { APP_DATE_FORMAT } from "../constants";
import StyledToolTip from "../../../common/StyledToolTip";

const styles = (theme) => ({
  dayWithDotContainer: {
    position: "relative",
  },
  dayWithDot: {
    position: "absolute",
    height: 0,
    width: 0,
    border: "3px solid",
    borderRadius: 4,
    borderColor: theme.palette.primary.main,
    right: "16%",
    top: "76%",
  },
  dayWithDotSelected: {
    borderColor: theme.white,
  },
  holiday: {
    "& button": {
      color: theme.error,
    },
  },
  holidayDateRangeDay: {
    color: theme.error,
  },
  disabled: {
    opacity: 0.5,
  },
  selectedDateColor: {
    color: theme.white,
  },
  defaultDateColor: {
    color: "#000",
  },
});

const InitializedPlanDay = withStyles(styles)(
  ({ DayComponent, isSelectedDate, classes }) => {
    return (
      <div className={classes.dayWithDotContainer}>
        {DayComponent}
        <div
          className={`${classes.dayWithDot} ${
            isSelectedDate ? classes.dayWithDotSelected : ""
          }`}
        ></div>
      </div>
    );
  }
);

const CustomDay = withStyles(styles)(
  ({ dayComponent, classes, isHoliday, isDisabled, holidayName }) => (
    <StyledToolTip title={holidayName ? holidayName : ""}>
      <div
        className={
          isHoliday
            ? `${classes.holiday} ${isDisabled ? classes.disabled : ""}`
            : null
        }
      >
        {dayComponent}
      </div>
    </StyledToolTip>
  )
);

const CustomDateRenderer = ({
  day,
  selectedDate,
  dayComponent,
  isInitializedPlanDate,
  isHoliday,
  isDisabled,
  holidayName,
  dayInCurrentMonth
}) => {
  const DayComponent = (
    <CustomDay
      dayComponent={dayComponent}
      isHoliday={isHoliday}
      isDisabled={isDisabled}
      holidayName={holidayName}
    />
  );
  if (isInitializedPlanDate && dayInCurrentMonth) {
    return (
      <InitializedPlanDay
        dayInCurrentMonth
        DayComponent={DayComponent}
        isSelectedDate={
          format(selectedDate, APP_DATE_FORMAT) === format(day, APP_DATE_FORMAT)
        }
      />
    );
  }
  return DayComponent;
};

const CustomDateRangeDay = withStyles(styles)(
  ({ day, classes, isHoliday, isDisabled, holidayName, isSelectedDate }) => (
    <StyledToolTip title={holidayName ? holidayName : ""}>
      <div
        className={`
          ${
            isSelectedDate
              ? classes.selectedDateColor
              : classes.defaultDateColor
          }`}
      >
        <div
          className={
            isHoliday
              ? `${classes.holidayDateRangeDay} ${
                  isDisabled ? classes.disabled : ""
                }`
              : null
          }
        >
          {day}
        </div>
      </div>
    </StyledToolTip>
  )
);

const CustomDateRangeDayRenderer = ({
  day,
  startDate,
  endDate,
  isInitializedPlanDate,
  isHoliday,
  isDisabled,
  holidayName,
  formattedDateToRender,
}) => {
  const formattedCalendarDate = format(day, APP_DATE_FORMAT);
  const isSelectedDate =
    format(startDate, APP_DATE_FORMAT) === formattedCalendarDate ||
    format(endDate, APP_DATE_FORMAT) === formattedCalendarDate;
  const DayComponent = (
    <CustomDateRangeDay
      day={formattedDateToRender}
      isHoliday={isHoliday}
      isDisabled={isDisabled}
      holidayName={holidayName}
      isSelectedDate={isSelectedDate}
    />
  );
  if (isInitializedPlanDate) {
    return (
      <InitializedPlanDay
        DayComponent={DayComponent}
        isSelectedDate={isSelectedDate}
      />
    );
  }
  return DayComponent;
};

export { CustomDateRenderer, CustomDateRangeDayRenderer };
